import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { isNil, useInterval } from '@grandvisionhq/utils';
import '../models/adyen/payment-type.js';
import '../models/cart-payment-methods/cart-payment-methods.js';
import '../models/googlePay/types.js';
import '../models/payment/types.js';
import '../models/paypal/context.js';
import '@grandvisionhq/icons';
import { errorsMapping } from '../mappers/errors-mapping.js';
import { mapPaymentState } from '../mappers/payment-state.js';
import '../operations/queries/get-cart-payment-methods.js';
import '../operations/queries/get-cart-express-payment-methods.js';
import { GET_PAYMENT_STATUS_BY_TOKEN } from '../operations/queries/get-payment-status-by-token.js';

const useGetPaymentStatusByToken = ({ onError , onCompleted , token , pollInterval =5000  } = {
    token: ''
})=>{
    const [getPaymentStatus, { data , error: apolloError , refetch , called  }] = useLazyQuery(GET_PAYMENT_STATUS_BY_TOKEN, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            onError && onError({
                reason: 'QUERY',
                error
            });
        },
        onCompleted () {
            onCompleted && onCompleted('getOrderByToken');
        },
        fetchPolicy: 'network-only',
        variables: {
            token
        }
    });
    const [paymentState, setPaymentState] = React.useState(undefined);
    const [error1, setError] = React.useState();
    React.useEffect(()=>{
        if (!apolloError) return;
        setError(errorsMapping.SOMETHING_WENT_WRONG);
    }, [
        apolloError
    ]);
    React.useEffect(()=>{
        if (paymentState === 'Paid' || paymentState === 'Failed' || !isNil(error1)) return;
        const currentPaymentState = mapPaymentState(data === null || data === void 0 ? void 0 : data.getOrderByToken);
        setPaymentState(currentPaymentState);
    }, [
        data,
        error1,
        paymentState
    ]);
    const handler = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        if (called && refetch) {
            yield refetch();
        } else {
            getPaymentStatus();
        }
    }), [
        getPaymentStatus,
        called,
        refetch
    ]);
    const options = React.useMemo(()=>({
            when: paymentState !== 'Paid' && paymentState !== 'Failed' && isNil(error1),
            startImmediate: true
        })
    , [
        paymentState,
        error1
    ]);
    useInterval(handler, pollInterval, options);
    return React.useMemo(()=>({
            paymentState,
            error: error1
        })
    , [
        error1,
        paymentState
    ]);
};

export { useGetPaymentStatusByToken };
//# sourceMappingURL=use-get-payment-status-by-token.js.map
